export class JobSalaryType {
    readonly name: string;
    readonly id: number;

    public isIn = (arr: { jobSalaryTypeId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.jobSalaryTypeId === this.id) >= 0;
    };

    private constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    public static PerYear = new JobSalaryType(10, "per year");
    public static PerHour = new JobSalaryType(20, "per hour");

    public static asArray = () => [
        JobSalaryType.PerHour,
        JobSalaryType.PerYear,
    ];

    public static fromId = (id: number) =>
        JobSalaryType.asArray().find(t => t.id === id);

    public static isPerYear = (id: number): boolean =>
        id === JobSalaryType.PerYear.id;

    public static isPerHour = (id: number): boolean =>
        id === JobSalaryType.PerHour.id;
}
